module.exports = __webpack_public_path__ + "img/solution-bg-vitrine.ccc7e5c8.35c603e0.jpg";